export default __webpack_public_path__ + "static/media/landingChat.b6e7e52a.svg";